import { createSlice } from '@reduxjs/toolkit';

// Mirrors redux/slices/appInstance structure (slice + generic setField reducer). `list` holds
// the last AuditQueryResult (Items/TotalCount/Page/PageSize/WindowClamped); `filter` holds the
// last-applied query params so paging/refresh can rehydrate without re-deriving them.
const initialState = {
  list: [],
  filter: {},
};

const reducer = {
  setFieldAuditLog(state, action) {
    const { field, value } = action.payload ?? {};
    if (field) {
      state[field] = value;
    }
  },
};

const slice = createSlice({
  name: 'auditLog',
  initialState,
  reducers: reducer,
});

export const { setFieldAuditLog } = slice.actions;

export default slice.reducer;
